module.exports = __webpack_public_path__ + "assets/img/left_2.d320e62f.png";